import { css } from 'styled-components';

export const Menu = css`
  body {
    .chakra-menu__menu-list {
      border: 0;
      box-shadow: 1px 1px 6px rgba(64, 26, 15, 0.25);
    }
  }
`;
